/**
 * @Description: 修改配送区域的界面
 * @Author Jiang
 * @Date 2020/8/18 15:00
 */
import React, {Component} from "react";
import {Button, Card, Input, List, message, Skeleton} from "antd";
import {Map, Marker, PolyEditor, Polygon} from "react-amap";
import './index.less'
import {getShopInfo, getShopUpdateDeliver} from "../../../../constants/api";
import {removeToken} from "../../../../utils/cookie";

import {COMMON_ROUTER} from "../../../../constants";

// const count = 3;
// const fakeDataUrl = `https://randomuser.me/api/?results=${count}&inc=name,gender,email,nat&noinfo`;
export default class EditArea extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      hasMore: true,
      shopId: '',
      addressGeo: [116.2317, 39.5427],
      deliverGeo: ''
    }
    this.editorEvents = {
      created: (ins) => {
        console.log(ins)
      },
      addnode: () => {
        console.log('polyeditor addnode')
      },
      adjust: () => {
        console.log('polyeditor adjust')
      },
      removenode: () => {
        console.log('polyeditor removenode')
      },
      end: (target) => {
        console.log(target)
        let allPath = target.target.getPath()
        let pathTemp = []
        allPath.map((item, index) => {
          let path = [item.lng, item.lat]
          pathTemp.push(path)
        })
        let {selected, features} = this.state
        if (features[selected]) {
          features[selected].geometry.coordinates = [pathTemp]
          this.setState({
            features: features
          })
        }

      },
    };
  }

  componentWillMount() {
    this.setState({
      shopId: this.props.location.state.shopId
    })
  }

  componentDidMount() {
    /* this.getDeliveryArea()*/
    this.getDeliveryArea()
  }


  getDeliveryArea() {
    getShopInfo({
      id: this.state.shopId,
    }).then((res) => {
      if (res.status === 200) {
        let data = res.data
        if (data.code === 0) {
          let addressGeo = data.data.addressGeo
          addressGeo = addressGeo.split(',');
          let deliverGeo = data.data.deliverGeo
          deliverGeo = JSON.parse(deliverGeo)
          let features = deliverGeo.features
          let featureTemp = []
          features.map((item, index) => {
            item['active'] = false;
            featureTemp.push(item)
          })

          this.setState({
            addressGeo: addressGeo,
            deliverGeo: deliverGeo,
            features: featureTemp
          })
        } else if (data.code === 50) {
          message.error(data.msg)
          removeToken();
        } else {
          message.error(data.msg)
        }
      }
    }).catch(error => {
      message.error(error.toString())
    })

    // axios.post(API_SHOP_DELIVERY_AREA, {
    //   id: this.state.shopId,
    // }).then(res => {
    //   if (res.status === 200) {
    //     let data = res.data;
    //     console.log('_____________')
    //     console.log(data)
    //     if (data.code === 0) {
    //       let addressGeo = data.data.addressGeo
    //       addressGeo = addressGeo.split(',');
    //       let deliverGeo = data.data.deliverGeo
    //       deliverGeo = JSON.parse(deliverGeo)
    //       let features = deliverGeo.features
    //       let featureTemp = []
    //       features.map((item, index) => {
    //         item['active'] = false;
    //         featureTemp.push(item)
    //       })
    //
    //       this.setState({
    //         addressGeo: addressGeo,
    //         deliverGeo: deliverGeo,
    //         features: featureTemp
    //       })
    //
    //     } else {
    //       message.error(data.msg, 1)
    //     }
    //   }
    // }).catch(error => {
    //
    // })
  }

  /**
   * @Description: 获取不同颜色的地图
   * @Author Jiang
   * @Date 2020/8/19 15:50
   */
  getAreaColor = (index) => {
    switch (index) {
      case 0:
        return 'rgba(255,38,16,0.55)'
      case 1:
        return 'rgba(255,207,37,0.59)'
      case 2:
        return 'rgb(29,122,25,0.5)'
      case 3:
        return 'rgb(45,47,235,0.5)'
      case 4:
        return 'rgb(255,52,234,0.5)'
      case 5:
        return 'rgb(54,255,54,0.5)'
      case 6:
        return 'rgba(194,149,255,0.59)'
      case 7:
        return 'rgba(255,30,12,0.76)'
    }
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180)
  }

  rad2deg(rad) {
    return rad * (180 / Math.PI)
  }

  squarePoint = (lng, lat, distance = 0.5) => {
    let dlng = 2 * Math.asin(Math.sin(distance / (2 * 6371) / Math.cos(this.deg2rad(lat))))
    dlng = this.rad2deg(dlng);
    let dlat = distance / 6371;
    dlat = this.rad2deg(dlat)

    return [
      [lng + dlng, lat + dlat],//东北
      [lng - dlng, lat + dlat],//西北
      [lng - dlng, lat - dlat],//西南
      [lng + dlng, lat - dlat],//东南
    ]
  }

  addArea = () => {
    let temp = this.state.features
    temp.map((item,index) => {
      item.active = false
    })
    this.setState({
      features:temp
    },() => {
    let featuresTemp = this.state.features
    //根据店铺位置，获取4个点
    let center = this.state.addressGeo
    let lng = center[0]

    lng = parseFloat(lng)
    let lat = center[1]
    lat = parseFloat(lat)
    let coordinates = this.squarePoint(lng, lat, 2)
    let obj = {
      geometry: {
        coordinates: [coordinates],
        type: 'Polygon'
      },
      properties: {
        area_agent_fee: 0,
        area_type: "NORMAL",
        delivery_price: 0,
        lpd_properties: "{}",
        manual_weight: 0,
        max_weight: 0,
        multiPeriod: {times: [["00:00:00", "23:59:00"]]},
        product_id: 0,
        system_weight: 0,
        weight_type: 1
      }
    }
    featuresTemp.push(obj)

    this.setState({
      features:featuresTemp
    })
    })

  }

  del = (index,e) => {
    e.stopPropagation()
    let featuresTemp = this.state.features;
    featuresTemp.map((item,i) => {
      item.active = false
    })
    this.setState({
      features:featuresTemp
    },() => {
      let temp = this.state.features
     temp.splice(index,1)
        this.setState({
          features: JSON.parse(JSON.stringify(temp))
        })
      })


  }

  onSelectArea = (index) => {

    let featuresTemp = this.state.features;
    let selected = ''
    for (let i = 0; i < featuresTemp.length; i++) {
      if (featuresTemp[i].active === true) {
        selected = i
      }
      if (i === index) {
        featuresTemp[i].active = true
      } else {
        featuresTemp[i].active = false
      }
    }
    this.setState({
      features: featuresTemp,
      selected: selected,
    })
  }

  save = () => {

    let featuresTemp = this.state.features;
    if (featuresTemp.length === 0) {
      message.error('当前没有配送区域，请添加',1)
      return
    }
    let selected = ''
    for (let i = 0; i < featuresTemp.length; i++) {
      if (featuresTemp[i].active === true) {
        selected = i;
      }
      featuresTemp[i].active = false
    }
    this.setState({
      selected: selected
    }, () => {
      this.setState({
        features: featuresTemp
      }, () => {
        let {features, deliverGeo} = this.state
        //处理修改数据
        deliverGeo.features = features
        let deliverGeoTemp = JSON.stringify(deliverGeo)

        getShopUpdateDeliver({
          shopId: this.state.shopId,
          content: deliverGeoTemp
        }).then((res) => {
          if (res.status === 200) {
            let data = res.data
            if (data.code === 0) {
              message.success('保存成功', 1, () => {
                this.props.history.push(COMMON_ROUTER + '/deliveryManage')
              })
            } else if (data.code === 50) {
              message.error(data.msg)
              removeToken();
            } else {
              message.error(data.msg)
            }
          }
        }).catch(error => {
          message.error(error.toString())
        })
        // axios.post(API_SHOP_AREA_SAVE, {
        //   shopId: this.state.shopId,
        //   content: deliverGeoTemp
        // }).then(res => {
        //   console.log(res)
        //   if (res.status === 200) {
        //     let data = res.data;
        //     if (data.code === 0) {
        //       message.success('保存成功', 1, () => {
        //         this.props.history.push(COMMON_ROUTER + '/deliveryManage')
        //       })
        //     } else {
        //       message.error(data.msg, 1)
        //     }
        //   }
        // }).catch(error => {
        //
        // })
      })
    })
  }

  handleChange = (type, index, e) => {

    let {features} = this.state
    let properties = features[index].properties

    switch (type) {
      case "area_agent_fee":
        properties.area_agent_fee = e.target.value
        break;
      case "delivery_price":
        properties.delivery_price = e.target.value
        break;
      case 'time_start':
        properties.multiPeriod.times[0][0] = e.target.value
        break;
      case 'time_end':
        properties.multiPeriod.times[0][1] = e.target.value
        break;
      case "max_weight":
        properties.max_weight = e.target.value
        break;
      default:
    }
    features[index].properties = properties
    this.setState({
      features: features
    })
  }
  exist = () => {
    this.props.history.push(COMMON_ROUTER + '/deliveryManage')
  }


  render() {
    return (
      <div className='container-editarea'>
        { <Map zoom={12} amapkey={'e73ee0f829ee336137ca9eabdee6382e'}
                                       center={this.state.addressGeo}>
          <Marker position={this.state.addressGeo}/>
          {this.state.features && this.state.features.map((item, index) => {
            return <Polygon key={index} path={item.geometry.coordinates[0]}
                            style={{fillColor: this.getAreaColor(index), strokeColor: this.getAreaColor(index)}}>
              <PolyEditor active={item.active} events={this.editorEvents}/>
            </Polygon>
          })}
        </Map>
        }


        <div className='delivery-area'>
          <Card title={'配送区域'} headStyle={{height: '10px', lineHeight: "10px", fontSize: "14px", fontWeight: "700"}}
                style={{width: '100%'}}>
            <div className='demo-infinite-containe'>
              <List
                className="demo-loadmore-list"
                itemLayout="horizontal"
                dataSource={this.state.features}
                renderItem={(item, index) => (
                  <List.Item>
                    <Skeleton avatar title={false} loading={item.loading} active>
                      <div className='editor-content' onClick={this.onSelectArea.bind(this, index)}>
                        <div className="editor-area__type"><span>区域 {index + 1}</span> <span
                          className="editor-area__btn--delete" onClick={this.del.bind(this, index)}>删除</span>
                        </div>
                        <div>
                          <div className={'row_label'}>
                            <span className={'label_price'}>起送价</span>
                            <Input className='input_price'
                                   onChange={this.handleChange.bind(this, 'area_agent_fee', index)}
                                   defaultValue={item.properties.area_agent_fee}
                                   addonAfter={'元'}/>
                          </div>
                          <div className={'row_label'}>
                            <span className={'label_price'}>配送费</span>
                            <Input className='input_price'
                                   onChange={this.handleChange.bind(this, 'delivery_price', index)}
                                   style={{marginBottom: "20px"}} defaultValue={item.properties.delivery_price}
                                   addonAfter={'元'}/>
                          </div>

                          <div className={'row_label'}>
                            <span className='label_price'>生效时间</span>
                            <div className='effect_time'>
                              <Input onChange={this.handleChange.bind(this, 'time_start', index)}
                                     defaultValue={item.properties.multiPeriod.times[0][0]}
                                     style={{border: 0, width: '65px', fontSize: "10px"}}/>
                              <span>至</span>
                              <Input onChange={this.handleChange.bind(this, 'time_end', index)}
                                     defaultValue={item.properties.multiPeriod.times[0][1]}
                                     style={{border: 0, width: '65px', fontSize: "10px"}}/>
                            </div>
                          </div>
                          {/* <div className={'row_label'}>
                            <span className={'label_price'}>最大重量</span>
                            <Input onChange={this.handleChange.bind(this, 'max_weight', index)}
                                   className={'input_price'}
                                   defaultValue={item.properties.max_weight}
                                   addonAfter={'克'}/>
                          </div>*/}
                        </div>
                      </div>
                    </Skeleton>
                  </List.Item>
                )}
              />
              <div>
                <Button onClick={this.addArea.bind(this)} className='add_area'>添加配送区域</Button>
              </div>
              <div className='save_exist'>
                <Button type={'primary'} onClick={this.save.bind(this)}>
                  保存
                </Button>
                <Button type={'danger'} onClick={this.exist.bind(this)}>
                  返回
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    )
  }


}




// WEBPACK FOOTER //
// ./src/pages/shopmanage/deliverymanage/editarea/index.js